import React from 'react';
import { Typography } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';
import { RequestFormValidatedState } from '@interfaces/RequestForm/forms/RequestFormValidatedState';
import { useDocumentRequestContext } from '@components/RequestForm/DocumentRequest/DocumentContext/DocumentRequestContext';
import { SelectedDocumentAction } from '@components/RequestForm/DocumentRequest/DocumentContext/DocumentRequestContextType';
import { DocumentRow } from '@components/RequestForm/DocumentRequest/DocumentRow/DocumentRow';
import CaseStatus from '@interfaces/CaseStatus';

export const DocumentList: React.FC = () => {
	const { setSelectedIndexAndAction } = useDocumentRequestContext();
	const { watch, setValue } = useFormContext<RequestFormValidatedState>();
	const [documents, attachments, status] = watch(['documents', 'attachments', 'status']);

	if (!documents && !attachments) {
		return null;
	}

	const setSelectedDocumentToDelete = (id: string) => {
		setSelectedIndexAndAction({
			id,
			action: SelectedDocumentAction.DELETE,
		});
	};

	const setSelectedDocumentToPreview = (id: string) => {
		setSelectedIndexAndAction({
			id,
			action: SelectedDocumentAction.PREVIEW,
		});
	};

	// Convert the record to an array of entries to map over
	const documentEntries = documents && Object.entries(documents);
	const totalDocuments = (documentEntries?.length || 0) + (attachments?.length || 0);

	const handleDeleteSelectedAttachment = (id: string) => {
		const remainingAttachments = attachments?.filter((attachment) => attachment.id !== id);
		setValue('attachments', remainingAttachments);
	};

	return (
		<>
			{((documentEntries && documentEntries.length > 0) || (status === CaseStatus.CANCELLED && totalDocuments > 0)) && (
				<Typography variant="body1" component="h3">
					Uploaded ({status === CaseStatus.CANCELLED ? totalDocuments : documentEntries?.length})
				</Typography>
			)}
			{status === CaseStatus.CANCELLED && (
				attachments?.map((attachment) => (
					<DocumentRow
						key={attachment.id}
						name={attachment.file}
						handleDeleteSelectedDoc={() => handleDeleteSelectedAttachment(attachment.id)}
					/>
				))
			)}
			{documentEntries?.map(([id, file]) => (
				<DocumentRow
					key={id}
					name={file.name}
					handleDeleteSelectedDoc={() => setSelectedDocumentToDelete(id)}
					handleOpenPreview={() => setSelectedDocumentToPreview(id)}
				/>
			))}
		</>
	);
};
